import { render, staticRenderFns } from "./CustomTag.vue?vue&type=template&id=094384c8&scoped=true"
import script from "./CustomTag.vue?vue&type=script&lang=js"
export * from "./CustomTag.vue?vue&type=script&lang=js"
import style0 from "./CustomTag.vue?vue&type=style&index=0&id=094384c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094384c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094384c8')) {
      api.createRecord('094384c8', component.options)
    } else {
      api.reload('094384c8', component.options)
    }
    module.hot.accept("./CustomTag.vue?vue&type=template&id=094384c8&scoped=true", function () {
      api.rerender('094384c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom-tag/CustomTag.vue"
export default component.exports